"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureAccess = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultState = {
  isFetching: false,
  byId: {},
  order: [],
  error: undefined
};

var featureAccess = function featureAccess(state, action) {
  if (state === void 0) {
    state = defaultState;
  }

  switch (action.type) {
    /* organisation map action handling */
    case 'FEATURE_ACCESS_FAILURE':
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case 'FEATURE_ACCESS_REQUEST':
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case 'FEATURE_ACCESS_SUCCESS':
      return _extends({}, state, {
        isFetching: false
      }, action.payload, {
        error: undefined
      });

    default:
      return state;
  }
};

exports.featureAccess = featureAccess;